import React from "react";

function Navbar() {
  return (
    <nav
      style={{
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
        padding: "0.5rem 2rem",
        backgroundColor: "#0f172a",
        color: "#e5e7eb",
        boxShadow: "0 2px 4px rgba(0,0,0,0.3)",
        position: "sticky",
        top: 0,
        zIndex: 1000,
      }}
    >
      {/* Logo */}
      <div style={{ display: "flex", alignItems: "center" }}>
        <img
          src="/main.jpeg"
          alt="main logo"
          style={{ width: "3rem", borderRadius: "10px", marginRight: "1rem" }}
        />
        <span
          style={{ fontSize: "1.5rem", fontWeight: "bold", color: "#60a5fa" }}
        >
          Ixmeh_apps
        </span>
      </div>

      {/* Navigation Links */}
      <div style={{ display: "flex", gap: "1.5rem", fontSize: "1rem" }}></div>
    </nav>
  );
}

// Common link style
const linkStyle = {
  color: "#d1d5db",
  textDecoration: "none",
  transition: "color 0.2s",
  fontWeight: "500",
};

export default Navbar;
